import { render } from "./ShowMessages.vue?vue&type=template&id=34329063"
import script from "./ShowMessages.vue?vue&type=script&lang=js"
export * from "./ShowMessages.vue?vue&type=script&lang=js"

import "./ShowMessages.vue?vue&type=style&index=0&id=34329063&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__